/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UpdateDataSecondStageRequestMktuListInner
 */
export interface UpdateDataSecondStageRequestMktuListInner {
  /**
   * Наименование товаров/услуг класса
   * @type {string}
   * @memberof UpdateDataSecondStageRequestMktuListInner
   */
  text: string
  /**
   * Номер класса МКТУ (1–45)
   * @type {number}
   * @memberof UpdateDataSecondStageRequestMktuListInner
   */
  classNum: number
}

/**
 * Check if a given object implements the UpdateDataSecondStageRequestMktuListInner interface.
 */
export function instanceOfUpdateDataSecondStageRequestMktuListInner(
  value: object
): value is UpdateDataSecondStageRequestMktuListInner {
  if (!('text' in value) || value['text'] === undefined) return false
  if (!('classNum' in value) || value['classNum'] === undefined) return false
  return true
}

export function UpdateDataSecondStageRequestMktuListInnerFromJSON(
  json: any
): UpdateDataSecondStageRequestMktuListInner {
  return UpdateDataSecondStageRequestMktuListInnerFromJSONTyped(json, false)
}

export function UpdateDataSecondStageRequestMktuListInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDataSecondStageRequestMktuListInner {
  if (json == null) {
    return json
  }
  return {
    text: json['text'],
    classNum: json['classNum'],
  }
}

export function UpdateDataSecondStageRequestMktuListInnerToJSON(
  value?: UpdateDataSecondStageRequestMktuListInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    text: value['text'],
    classNum: value['classNum'],
  }
}
